import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import router from '@/router'
import store from './store/store'
import { HttpClientPlugin } from '@/components/shared/http-client'
import VueExcelEditor from 'vue-excel-editor'
import VCalendar from 'v-calendar'
import VueConfetti from 'vue-confetti'
import VueTour from 'vue-tour'
import { vMaska } from 'maska'

import tasksPoller from './middleware/tasks-poller'

require('vue-tour/dist/vue-tour.css')

if (process.env.NODE_ENV === 'development') {
  import('./plugins/vue-error-handler')
}

Vue.use(HttpClientPlugin)
Vue.config.productionTip = false
Vue.use(VueExcelEditor)
Vue.use(VCalendar, {
  componentPrefix: 'vc',
})
Vue.use(VueConfetti)
Vue.use(VueTour)
Vue.directive('maska', vMaska)

Vue.prototype.$alert = (payload, timeout) => {
  if (typeof payload === 'string' || payload instanceof String) {
    store.dispatch('setGlobalAlert', {
      show: true,
      timeout: timeout,
      text: payload,
    })
  } else {
    store.dispatch('setGlobalAlert', payload)
  }
}

Vue.prototype.$error = (payload, timeout) => {
  if (typeof payload === 'string' || payload instanceof String) {
    store.dispatch('setGlobalErrorAlert', {
      show: true,
      timeout: timeout,
      text: payload,
    })
  } else {
    store.dispatch('setGlobalErrorAlert', payload, timeout)
  }
}

// if click event is passed, the info box will show at the position of the event
Vue.prototype.$info = (text, evt) => {
  store.dispatch('setGlobalInfo', {
    show: true,
    text: text,
    evt: evt,
  })
}

Vue.prototype.$loading = payload => {
  store.dispatch('setLoading', payload)
}

async function init() {
  new Vue({
    vuetify,
    store: store,
    router,
    render: h => h(App),
  }).$mount('#app')
}

init()

router.afterEach(tasksPoller)

// I should use router from the source elsewhere, but that was causing the app not to start..
export { router }
